import { render } from "./GroupBy.vue?vue&type=template&id=6512afc6&scoped=true"
import script from "./GroupBy.vue?vue&type=script&lang=js"
export * from "./GroupBy.vue?vue&type=script&lang=js"

import "./GroupBy.vue?vue&type=style&index=0&id=6512afc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6512afc6"]])

export default __exports__